export enum MrnConfigType {
  typeCoding = 'typeCoding',
  system = 'system',
}

export interface MrnConfig {
  configType: MrnConfigType;
  system: string;
  code?: string;
}

export type SupportedIntlPhoneNumberValidation = 'us' | 'none';

export interface Project {
  id: string;
  name?: string;
  genomeBuild?: string;
  description?: string;
  lrn?: string;
  deletionDate?: string;
  owner?: string;
  auditLogging: boolean;
  shortName?: string;
  mrnConfig?: MrnConfig;
  part11?: boolean;
}
